import {Component, Inject, Input, OnInit} from '@angular/core';
import {AbstractComponent} from "@components";
import {
  ApplicationFormSettings,
  Competitor, CompetitorFilter,
  CompetitorStatus, DEFAULT_PAGE_INDEX,
  EventItem,
  Lookups,
  PagedFilter,
  Pages,
  Race, RaceRegistration, RaceSettings
} from "@model";
import {ExportService} from "@services";
import {
  REGISTER_TO_RACE
} from "../../../../../../app-routing.module";
import {ActivatedRoute, Router} from "@angular/router";
import {FormControl, FormGroup} from "@angular/forms";
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'app-event-management',
  templateUrl: './event-management.component.html',
  styleUrls: ['./event-management.component.scss']
})
export class EventManagementComponent extends AbstractComponent implements OnInit {
  @Input() eventItem: EventItem | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() competitors: Competitor[] = [];
  @Input() raceRegistrations: RaceRegistration[] = [];
  @Input() applicationFromSettingsList: ApplicationFormSettings[] = [];
  @Input() settingsList: RaceSettings[] = [];

  competitorStatuses: CompetitorStatus[] = [CompetitorStatus.REG, CompetitorStatus.BIB, CompetitorStatus.RDY,
    CompetitorStatus.STA, CompetitorStatus.FIN, CompetitorStatus.DSQ, CompetitorStatus.DNF, CompetitorStatus.TLE, CompetitorStatus.DNS];

  filter: PagedFilter<CompetitorFilter> | undefined;
  raceRegistrationsPage: number = DEFAULT_PAGE_INDEX;
  hasMoreRaceRegistrations: boolean = false;
  name: string | undefined;
  organiserId: number | undefined;
  disableRegisterToRace: boolean = false;
  category: number | undefined = undefined;
  gender: number | undefined = undefined;
  page: number = 1;
  selectedStatus: CompetitorStatus | undefined;

  searchForm: FormGroup<{ name: FormControl<any>; status: FormControl<any> }> = new FormGroup({
    name: new FormControl(),
    status: new FormControl(),
  });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private exportService: ExportService,
    @Inject(DOCUMENT) private document: Document
  ) {
    super();
  }

  ngOnInit() {
    this.subscribeToFilterChange();
    this.disableRegisterToRace = this.isDisableRegisterToRace();
  }

  private subscribeToFilterChange(): void {
    this.subscriptions.push(this.searchForm.valueChanges.subscribe(_ => {
        this.name = this.searchForm.controls.name.value;
        this.selectedStatus = this.searchForm.controls.status.value;
      }
    ));

  }

  private getRace(raceId: number | undefined): Race | undefined {
    return raceId ? this.eventItem?.racesList?.find(race => race.id === raceId) : undefined;
  }

  registerToRace() {
    if ((this.eventItem?.racesList?.length ?? 0) > 0) {
      this.router.navigate([REGISTER_TO_RACE], {
        relativeTo: this.route,
        queryParams: {
          eventId: this.eventItem!.id,
          raceId: this.eventItem!.racesList![0].id
        }
      });
    }
  }

  isDisableRegisterToRace() {
    let disableRegisterToRace: boolean = true;
    if ((this.eventItem?.racesList?.length ?? 0) > 0) {
      for (var race of this.eventItem?.racesList!) {
        if (race.raceRegistrationEnabled) {
          disableRegisterToRace = false;
          break;
        }
      }
    }
    return disableRegisterToRace;
  }

  getFileFromServer(type: string) {
    this.exportService.downloadStartListFile(type, +this.route.snapshot.queryParams['eventId']).subscribe(
      (blob: Blob) => {
        const formattedDateTime: string = this.getCurrentDateTimeFormatted();
        const filename: string = type + '_' + formattedDateTime + '.' + type;
        const downloadLink: HTMLAnchorElement = this.document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.setAttribute('download', filename);
        this.document.body.appendChild(downloadLink);
        downloadLink.click();
      },
      error => {
        console.error('Error downloading file:', error);
      }
    );
  }


  getEventParticipanstFileFromServer(type: string, filter: PagedFilter<CompetitorFilter> | undefined) {
    if (filter === undefined || filter === null) {
      let filterNull: CompetitorFilter = new CompetitorFilter();
      filterNull.eventId = +this.route.snapshot.queryParams['eventId'],
        this.filter = new PagedFilter(new Pages(undefined, 1), filterNull);
      filter = this.filter;
    }
    this.exportService.downloadCompetitorsListForEventFile(type, filter).subscribe(
      (blob: Blob) => {
        const formattedDateTime: string = this.getCurrentDateTimeFormatted();
        const filename: string = type + '_' + formattedDateTime + '.' + type;
        const downloadLink: HTMLAnchorElement = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      },
      error => {
        console.error('Error downloading file:', error);
      }
    );
  }


  // createFilter(filter: PagedFilter<CompetitorFilter> | undefined){
  //   let filterNull: CompetitorFilter = new CompetitorFilter();
  //   filterNull.name = this.name;
  //   filterNull.eventId = +this.route.snapshot.queryParams['eventId'];
  //   if(this.selectedStatus){
  //     filterNull.competitorStatuses = [this.selectedStatus];
  //   }
  //   this.filter = new PagedFilter(new Pages(undefined, 0), filterNull);
  // }

  getCurrentDateTimeFormatted(): string {
    const currentDateTime = new Date();
    const year: number = currentDateTime.getFullYear();
    const month: string = this.padNumber(currentDateTime.getMonth() + 1, 2);
    const day: string = this.padNumber(currentDateTime.getDate(), 2);
    return `${year}-${month}-${day}`;
  }

  padNumber(num: number, size: number): string {
    let numStr: string = num.toString();
    while (numStr.length < size) {
      numStr = '0' + numStr;
    }
    return numStr;
  }

  protected readonly RaceRegistration = RaceRegistration;
}
